import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Question = ({ question, options = [], correctAnswer, onAnswered }) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);

  const handleAnswer = () => {
    if (selectedOption === correctAnswer) {
      setFeedback('Correct!');
      setShowSuccessOverlay(true);
      setTimeout(() => {
        setShowSuccessOverlay(false);
        setFeedback(null);
        onAnswered(true);
      }, 900);
    } else {
      setFeedback(`Incorrect. The correct answer is: ${correctAnswer}`);
      setTimeout(() => {
        setFeedback(null);
      onAnswered(false);
      }, 3000);
    }
  };

  return (
    <div>
      <h2 className="has-text-primary">Did you pay attention?</h2>
      <p className="has-text-white">{question}</p>
      <div className="is-flex is-align-items-center is-justify-content-center">
        <div className="select mr-2">
          <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
            <option value="" disabled>Select an option</option>
            {options.length > 0 && options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        </div>
        <button className="button is-warning" onClick={handleAnswer}>Submit</button>
      </div>
      {feedback && <p className="mt-2 has-text-warning">{feedback}</p>}
      <div className={`success-overlay ${showSuccessOverlay ? 'is-visible' : ''}`} aria-live="polite" role="status">
        <div className="success-card">
          <div className="success-icon">✓</div>
          <div className="success-title">Correct!</div>
          <div className="success-subtitle">Nice work — keep going.</div>
        </div>
      </div>
    </div>
  );
};

Question.propTypes = {
  question: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  correctAnswer: PropTypes.string.isRequired,
  onAnswered: PropTypes.func.isRequired
};

export default Question;
